import { HttpErrorResponse } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { DataService } from './services/data.service';
import { LoggerService } from './services/logger.service';
import { ValidationService } from './services/validation.service';
import { Prefrence } from 'src/app/module/pierhibico/model/interfaces';

@Component({
  selector: 'app-pierhibico',
  templateUrl: './pierhibico.component.html',
  styleUrls: ['./pierhibico.component.css'],
})
export class PIERHIBICOComponent implements OnInit {
  preference: Prefrence | null = null;
  email: string | undefined = '';
  tollfreeNo: string | undefined | null = '';
  faxNo: string | undefined | null = '';
  errorMessageIntialData: string = '';
  mailingAddress: string = '';
  dropingAddress: string ='';
  emailTo: string = '';
  logo: any;
  applicationPdf: any;
  mailingOffice: string='';
  mailingAddressLine: string='';
  mailingCityStateZip: string='';

  constructor(
    private dataService: DataService,
    private logger: LoggerService
  ) {}

  ngOnInit(): void {
    this.logo = 'app/module/pierhibico/assets/img/CO_Logo.jpg';
    this.dataService.getPreference().subscribe({
      next: (preferences: Prefrence) => {
        this.preference = preferences;

        this.faxNo = ValidationService.formatPhoneNumber(
          this.preference.preferenceValues?.['FAX_NUM']
        );
        this.applicationPdf = this.preference.paperApplication;
        this.tollfreeNo = ValidationService.formatPhoneNumber(this.preference.preferenceValues?.['TOLL_FREE_NUM']);

        this.email = this.preference.preferenceValues?.['EMAIL_ID'];
        this.emailTo = 'mailto:' + this.email;
        this.mailingAddress =
          '' +
          this.preference.preferenceValues?.['STATE_PROGRAM'] +
          ', ' +
          this.preference.preferenceValues?.['ADDRESS1_TXT'] +
          ', ' +
          this.preference.preferenceValues?.['CITY_TXT'] +
          ', ' +
          this.preference.preferenceValues?.['STATE_CD'] +
          ' ' +
          this.preference.preferenceValues?.['ZIP_CODE'];

          this.mailingOffice = '' + this.preference.preferenceValues?.['STATE_PROGRAM'];
          this.mailingAddressLine = '' + this.preference.preferenceValues?.['ADDRESS1_TXT'];
          this.mailingCityStateZip = '' + this.preference.preferenceValues?.['CITY_TXT'] +
          ', ' + this.preference.preferenceValues?.['STATE_CD'] +
          ' ' + this.preference.preferenceValues?.['ZIP_CODE'];

        this.dropingAddress =
        '' +
          this.preference.preferenceValues?.['DROPOFF_OFFICE'] +
          ', ' +
          this.preference.preferenceValues?.['DROPOFF_ADDRESS1_TXT'] +
          ', ' +
          this.preference.preferenceValues?.['DROPOFF_ADDRESS2_TXT'] +
          ', ' +
          this.preference.preferenceValues?.['DROPOFF_CITY'] +
          ', ' +
          this.preference.preferenceValues?.['DROPOFF_STATE_CD'] +
          ' ' +
          this.preference.preferenceValues?.['DROPOFF_ZIPCD'];


      },
      error: (err: HttpErrorResponse) => {
        this.logger.logMsg(err.error);
        const msg = 'Unable to get the Preference details: ' + err.message;
        this.errorMessageIntialData = msg;
      },
    });
  }

  openPaperApplication(){
    let bytes = this.applicationPdf;

    let response = this.base64ToArrayBuffer(bytes);
    let file = new Blob([response], { type: 'application/pdf' });
    let fileURL: any = URL.createObjectURL(file);
    //window.open(fileURL);
    let anchor = document.createElement('a');
    anchor.href = fileURL;
    anchor.download = 'PremiumPayment.pdf';
    anchor.click();
  }


  base64ToArrayBuffer(base64: any): ArrayBuffer {
    let binary_string = window.atob(base64);
    let len = binary_string.length;
    let bytes = new Uint8Array(len);
    for (let i = 0; i < len; i++) {
      bytes[i] = binary_string.charCodeAt(i);
    }
    return bytes.buffer;
  }
}
